$( document ).ready(function() {
  $('.custom-faq-related-content[data-heading-name!="category_1"]').hide();
  $($('[data-heading-name="category_1"]')[1]).addClass('c2-custom-border-top');
  $($('[data-heading-name="category_1"]')[$('[data-heading-name="category_1"]').length-1]).addClass('c2-custom-border-bottom');
});
  
$(document).on("click",".custom-faq-related-heading-content",function() {
  $('.custom-faq-related-heading-content.active').removeClass('active');
  $(this).addClass('active');
  
  var faq_type=$(this).data('heading-name');
  $('.custom-faq-related-content').hide(); 
  $('.custom-faq-related-content[data-heading-name="'+faq_type+'"]').show();
  $('.custom-faq-related-content').removeClass('c2-custom-border-top');
  $('.custom-faq-related-content').removeClass('c2-custom-border-bottom');
  $($('[data-heading-name="'+faq_type+'"]')[1]).addClass('c2-custom-border-top');
  $($('[data-heading-name="'+faq_type+'"]')[$('[data-heading-name="'+faq_type+'"]').length-1]).addClass('c2-custom-border-bottom');
  $('.custom-faq-content1 h3').text($(this).text().trim());
  
});
 


$(document).on("click",".custom-faq-related-content",function() {
  if($(this).hasClass('active')){
  	$(this).removeClass('active');
  }else{
	$(this).addClass('active');
  }
}); 



$(document).on("click", ".sidebar-block__heading", function () {
  $(this).parent().parent().toggleClass("filter-open")
});

// $(document).on("click", ".filter-btn", function () {
//   $(this).parent().parent().toggleClass("collection_filter-open")
// });



$('.c2_featuredcol .featured-collection').flickity({
          contain: true, 
          prevNextButtons: true,
          pageDots: true,
          groupCells: 2,
          adaptiveHeight: true,
          cellSelector: ".product__thumbnail"     
  });


$('.c2_new_collection .featured-collection').flickity({
          contain: true, 
          prevNextButtons: false,
          pageDots: false,
          freeScroll: true,
          groupCells: 2,
          cellSelector: ".product__thumbnail"     
  });
 
 if ($(window).width() <= 768) {
  $('.c2_new_collection .featured-collection').flickity('destroy');
 }

$(document).ready(function() {
    var main_cell = $('.c2_new_fcollection .featured-collection');
    var cellCount = main_cell.find('.product__thumbnail').length;

    main_cell.flickity({
        contain: 'left', 
        prevNextButtons: true,
        pageDots: cellCount > 2,
        groupCells: 2,
        cellSelector: ".product__thumbnail"
    });
});





$(document).ready(function() {
    var main_cell = $('.c2_new_scollection .featured-collection');
    var cellCount = main_cell.find('.product__thumbnail').length;

    main_cell.flickity({
        contain: 'left', 
        prevNextButtons: true,
        pageDots: cellCount > 2,
        groupCells: 2,
        cellSelector: ".product__thumbnail"
    });
});



   


 $('.testimonials_main').flickity({
          contain: true, 
         wrapAround: true,
          prevNextButtons: true,
          pageDots: true
 });

 if ($(window).width() <= 768) {
   $('.c2_logo .container').flickity({
           cellAlign: 'left', 
            freeScroll: true,
             groupCells: 4,
            prevNextButtons: false,
            pageDots: false
   }); 
 }
 
$(document).on("click",".menu__heading",function(){
  $(this).parent().toggleClass("menu-open"); 
});



$(document).on("click",".filter-btn",function() {
  $('.c2-slider-faceted-filter-form').addClass("c2-slider-filter-form-active"); 
  $('.fillter-overlay').addClass("fillter-overlay-active");
});

$(document).on("click",".faceted_filtering_heading .icon",function() {
  $('.c2-slider-faceted-filter-form').removeClass("c2-slider-filter-form-active");
  $('.fillter-overlay').removeClass("fillter-overlay-active");
});

$(document).on("click",".fillter-overlay-active",function() {
  $('.c2-slider-faceted-filter-form').removeClass("c2-slider-filter-form-active");
  $('.fillter-overlay').removeClass("fillter-overlay-active");
});
 
 


  

var acc = document.getElementsByClassName("accordionNew");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null; 
    } else {
      panel.style.maxHeight = "100%";
    }
  });
}


// Add to cart
 $(document).on('click','.cart_btn',function(e) {
    e.preventDefault();
    var productId = $(this).data('product-id');
    
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        quantity: 1,
        id: productId
      },
      dataType: 'json', 
      success: function(cart) {
        Shopify.theme.jsAjaxCart.showDrawer();
        Shopify.theme.jsAjaxCart.updateView();
        var scrollTopValue = $('.ajax-cart__product').eq(0).offset().top;
        $('.ajax_cart_main').animate({ scrollTop: scrollTopValue }, 'slow');

      }
    });
});


document.addEventListener('DOMContentLoaded', function () {
    // Select pagination elements
    const paginateElement = document.querySelector('.paginate');
    const paginationList = document.querySelector('.pagination-list');
    const viewMoreButton = document.querySelector('.pagination-button__load-more');
    const paginationType = '{{ pagination_type }}'; // Get pagination type from Liquid

    if (paginateElement && paginationType) {
        // Hide the standard pagination if load_more or infinite scroll is enabled
        if (paginationType === 'load_more' || paginationType === 'infinite_scroll' || paginationType === 'infinite_load_more') {
            paginationList.style.display = 'none';
        }

        if (viewMoreButton) {
            viewMoreButton.addEventListener('click', function (event) {
                event.preventDefault();

                let currentPage = parseInt(paginateElement.getAttribute('data-current-page'));
                const totalPages = parseInt(paginateElement.getAttribute('data-paginate-pages'));

                if (currentPage < totalPages) {
                    currentPage++;
                    paginateElement.setAttribute('data-current-page', currentPage);

                    // Update the displayed page number
                    if (paginationType !== 'load_more' && paginationType !== 'infinite_scroll' && paginationType !== 'infinite_load_more') {
                        paginationList.innerHTML = `Showing ${currentPage} of ${totalPages}`;
                    }

                    // Update the width of the pagination line
                    const paginationLine = paginateElement.querySelector('.pagination-line');
                    if (paginationLine) {
                        paginationLine.style.width = `${(currentPage * 100) / totalPages}%`;
                    }

                    // Load the new page content via AJAX
                    fetch(viewMoreButton.getAttribute('href'))
                        .then(response => response.text())
                        .then(html => {
                            const newContent = new DOMParser().parseFromString(html, 'text/html');
                            document.querySelector('.content-area').innerHTML += newContent.querySelector('.content-area').innerHTML;

                            const newNextUrl = newContent.querySelector('.pagination-button__load-more').getAttribute('href');
                            if (newNextUrl) {
                                viewMoreButton.setAttribute('href', newNextUrl);
                            } else {
                                viewMoreButton.style.display = 'none';
                            }
                        })
                        .catch(error => console.error('Error loading more content:', error));
                }
            });
        }
    }
});






















